import { loggedIn } from '../../../routes/conditional';
import {
  updateDeliveryPrefs,
  setDeliveryAddressOrderId,
} from '../../../redux/modules/orders';
import {
  getPendingOrdersDeliveryAddressOrderId,
  getConfirmDetailsList,
  getPendingOrdersDeliveryPreferenceFlow,
} from '../../../redux/modules/root-reducer';
import paths from '../../../routes/paths';

export const page = {
  path: '/orders/:orderId/cc-confirm-pharmacy',
  isAllowed: [loggedIn],
  action: ({ params }) => setDeliveryAddressOrderId(params.orderId),
};

export const confirmCollect = {
  actionPath: '/actions/confirm-collect',
  inputName: 'ccupdateDeliveryPrefs',
  action: ({ state }) => {
    const flow = getPendingOrdersDeliveryPreferenceFlow(state);
    return updateDeliveryPrefs(
      getPendingOrdersDeliveryAddressOrderId(state),
      getConfirmDetailsList(state),
      'cc',
      flow,
      paths.checkout.paymentDeliveryPreference
    );
  },
};
